import React, { FC } from 'react'
import { ListItemIcon, ListItemIconProps } from '@mui/material'

const EvtListItemIcon: FC<ListItemIconProps> = ({ children, ...props }) => {
    return <ListItemIcon {...props}>{children}</ListItemIcon>
}

export default EvtListItemIcon
